const selectBox = document.getElementById("delivery__method");
const date = document.getElementById("date");
const deliveryTime01 = document.getElementById("delivery_time_01");
const deliveryTime02 = document.getElementById("delivery_time_02");
const deliveryTime03 = document.getElementById("delivery_time_03");
const note = document.getElementById("cart-note");

function postData() {
  const selectedValue = selectBox.value;
  const dateValue = date.value;
  const deliveryTime01Value = deliveryTime01.value;
  const deliveryTime02Value = deliveryTime02.value;
  const deliveryTime03Value = deliveryTime03.value;
  const noteValue = note.value;

  const attributes = {
    attributes: {
      受取方法: selectedValue,
      受取希望日: dateValue,
      配送時間: deliveryTime01Value,
      配達時間: deliveryTime02Value,
      受取時間: deliveryTime03Value,
      注文メモ: noteValue,
    },
  };
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(attributes),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

selectBox.addEventListener("change", postData);
date.addEventListener("change", postData);
deliveryTime01.addEventListener("change", postData);
deliveryTime02.addEventListener("change", postData);
deliveryTime03.addEventListener("change", postData);
note.addEventListener("change", postData);
